export type VersionComarerOptions = {
  zeroExtend: boolean;
  lexicographical: boolean;
};

export const versionCompare = (v1: string, v2: string, options) => {
  const lexicographical = options && options.lexicographical;
  const zeroExtend = options && options.zeroExtend;
  const v1parts = v1.split('.');
  const v2parts = v2.split('.');
  let v1numbers, v2numbers: number[];

  function isValidPart(x) {
    return (lexicographical ? /^\d+[A-Za-z]*$/ : /^\d+$/).test(x);
  }

  if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
    return NaN;
  }

  if (zeroExtend) {
    while (v1parts.length < v2parts.length) {
      v1parts.push('0');
    }
    while (v2parts.length < v1parts.length) {
      v2parts.push('0');
    }
  }

  if (!lexicographical) {
    v1numbers = v1parts.map(Number);
    v2numbers = v2parts.map(Number);
  }

  for (let i = 0; i < v1numbers.length; ++i) {
    if (v2numbers.length === i) {
      return 1;
    }

    if (v1numbers[i] === v2numbers[i]) {
      continue;
    } else if (v1numbers[i] > v2numbers[i]) {
      return 1;
    } else {
      return -1;
    }
  }

  if (v1numbers.length !== v2numbers.length) {
    return -1;
  }

  return 0;
};
